import { render, staticRenderFns } from "./InstitutionalQnrResultsView.vue?vue&type=template&id=728684a8&scoped=true&"
import script from "./InstitutionalQnrResultsView.vue?vue&type=script&lang=js&"
export * from "./InstitutionalQnrResultsView.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionalQnrResultsView.vue?vue&type=style&index=0&id=728684a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728684a8",
  null
  
)

export default component.exports